module.exports = __webpack_public_path__ + "img/unlike_selected.da9b8b5b.png";